import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { getPerfis } from '../../../api';
import GridBase from '../../../components/grid_base';
import StatusPesquisar from '../../../components/status_pesquisar';
var COLUNAS = [
    {
        field: 'nome',
        headerName: 'Nome',
        width: 650,
    },
    {
        field: 'situacao',
        headerName: 'Situação',
        width: 150,
    },
];
var Perfis = function () {
    return (_jsx(GridBase, { pagina: PAGINAS.PERFIS, paginaPermissao: FUNCIONALIDADES.PERFIS, rota: ROUTES.PERFIS, columns: COLUNAS, filtrosIniciais: {
            situacao: null,
        }, fetchData: function (textoBusca, filtros, paginationModel) { return getPerfis(textoBusca, filtros.situacao === '-1' ? null : filtros.situacao, paginationModel); }, renderFiltros: function (filtros, atualizarFiltros) { return (_jsx(StatusPesquisar, { StatusPesquisa: filtros.situacao, filtrarGrid: function (_, novaSituacao) {
                atualizarFiltros({ situacao: novaSituacao });
            } })); } }));
};
export default Perfis;
